import { ComponentProps, FC } from 'react'
import styled from 'styled-components'

import { AddToBagButton as AddToBag } from '../../../../../components/atoms/AddToBagButton'
import { CtaButton } from '../../../../../components/atoms/CtaButton'
import { trackEvent } from '../../../../../lib/analytics'

type AddToBagButtonProps = {
  cta?: string
  className?: string
  icon?: React.ReactNode
  isDisabled?: boolean
  isProcessing?: boolean
  isWaitlist?: boolean
  onClickAddToBag: () => Promise<void>
} & Partial<ComponentProps<typeof AddToBag>>

interface AddToBagButtonContentWrapperProps {
  isIconVisible?: boolean
}

export const AddToBagButtonContentWrapper = styled.div<AddToBagButtonContentWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(4)};
  ${o => (o.isIconVisible ? `margin-right: ${o.theme.spacing(4)};` : '')}
`

export const AddToBagButton: FC<AddToBagButtonProps> = ({
  cta,
  className,
  icon,
  isDisabled,
  isProcessing,
  isWaitlist,
  onClickAddToBag,
  ...rest
}) => {
  const variant = isWaitlist ? 'ghost' : 'filled'
  const isIconVisible = !!icon && !isProcessing

  return (
    <AddToBag
      {...trackEvent({
        category: 'product details',
        action: 'add to cart',
        label: cta,
      })}
      ButtonComponent={CtaButton}
      allCaps
      aria-disabled={isDisabled}
      block
      className={className}
      data-testid='add-to-bag-button'
      disabled={isDisabled}
      isProcessing={isProcessing}
      onClick={onClickAddToBag}
      variant={variant}
      {...rest}
    >
      <AddToBagButtonContentWrapper isIconVisible={isIconVisible}>
        {isIconVisible && icon}
        <span aria-live='polite'>{cta}</span>
      </AddToBagButtonContentWrapper>
    </AddToBag>
  )
}
